export default __webpack_public_path__ + "static/intersection-1-36cfdf50695a78b1945857556e0d128f.jpg";